export class UserDefaultStates {
    id: string;
    upn: string;
    defaultStates: Array<string>;

    constructor() {
        this.defaultStates = new Array<string>();
    }
}
